/* 🤖 this file was generated by script */
export const wiconArrowNarrowDownRight = {
  name: 'arrow_narrow_down_right',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 6l12 12m0 0v-8m0 8h-8"/></svg>`,
};
